export var RECENT_PRODUCTS_TO_DISPLAY = 7;
export var ACTIVE_PRODUCTS_TO_DISPLAY = 6;
export var ORDER_ITEM_STATUS = {
  ACTIVE: 1
};
export var ORDER_ITEM_TYPE = {
  REMOVE: 3,
  SUSPEND: 4
};
export var END_DATE_TYPES = {
  RENEW: 1,
  EXPIRE: 2
};
export var DASHBOARD_ROUTE = 'index.customercare.customer.dashboard';
export var SUBSCRIPTION_LIST_ROUTE = 'index.customercare.customer.subscriptions.list';